import { createElement, render } from '../../../../js/utils/render'
import { Spoiler } from '../../../../js/components/Spoiler'
import Form from '../../../../js/Form/Form'

const getPaymentMethodTemplate = (data) => {
  const { title, description, tag, value, analytics, paymentType, paymentPrice, details, images } = data

  return (
    `<div class="auto-payment-form__type extended-autopayment-method" id="${value}">
      <label class="extended-autopayment-method__label">
        <input
          name="payment_type"
          value="${value}"
          type="radio"
          data-analytics="${analytics}"
          data-payment-type="${paymentType}"
          data-payment-price="${paymentPrice}"
          class="extended-autopayment-method__input sr-only"
        >

        <span class="extended-autopayment-method__box">
          <span class="extended-autopayment-method__header">
            <strong class="extended-autopayment-method__title t t--2">
              ${title}
            </strong>

            ${tag
              ? `<span
                   data-admin-theme="black"
                   class="extended-autopayment-method__tag ui-tag ui-tag--small ui-tag--bg"
                   style="--tag-bg-color: var(--accent-sale-color); --tag-text-color: var(--accent-always-black-color);"
                 >
                   ${tag.title}
                 </span>`
              : ''
            }
          </span>

          <span
            class="extended-autopayment-method__details"
            style="height: 0;"
          >
            <span class="extended-autopayment-method__desc p p--2">
              ${description}
            </span>

            ${details?.length
              ? `<span class="extended-autopayment-method__list f">
                  ${details.map(({ title, description }, i) => {
                    const isTotal = value !== 'cloudpayments' && i === details.length - 1

                    return (
                      `<span class="extended-autopayment-method__item ${isTotal ? 'extended-autopayment-method__item--total f f--16 f--m' : 'p p--2'}">
                        <span class="extended-autopayment-method__item-text">
                          ${title}
                        </span>

                        <span class="extended-autopayment-method__item-price">
                          ${description}
                        </span>
                      </span>
                    `)
                  }).join('')}
                </span>`
              : ''
            }
          </span>

          ${images?.length
            ? `<span class="extended-autopayment-method__images">
                ${images.map(({ src, alt }) => (`
                  <img
                    src="${src}"
                    alt="${alt}"
                    height="16"
                  >
                `)).join('')}
              </span>`
            : ''
          }
        </span>
      </label>
    </div>`
  )
}

export class AutoPaymentForm {
  constructor(wrapper, template, { nomenclatureId, methods }) {
    this.wrapper = wrapper
    this.template = template
    this.methods = methods

    this.methodsWrapper = template.querySelector('.auto-payment-form__types')
    this.form = template.querySelector('.form')
    this.form.nomenclature_id.value = nomenclatureId
    this.buttonContent = this.form.querySelector('.auto-payment-form__button .ui-button__text')

    this.selectPaymentType = null
    this.selectMethod = null
  }

  render() {
    if (!this.methods || this.methods.length === 0) {
      const error = new Error(`[AutoPaymentForm]: methods is required - ${this.methods}`)
      window.Sentry?.captureException(error)
      return
    }

    this.renderPaymentMethods()

    this.selectPaymentType = this.form.querySelector('.extended-autopayment-method__input')
    this.selectPaymentType.checked = true
    this.selectMethod = this.selectPaymentType.closest('.extended-autopayment-method')

    // TODO: Удалить после теста paymentAbTestGroup
    window.paymentAbTestGroup === 'B' && this.changeViewForBGroup()

    this.accordionInit()
    this.formInit()

    this.setButtonContent()

    this.form.addEventListener('change', this.formChangeHandler)
    this.form.addEventListener('form-sended', this.formSubmitHandler)

    render(this.wrapper, this.template)

    this.setDetailsHeight()
  }

  destroy() {
    this.form.removeEventListener('change', this.formChangeHandler)
    this.form.removeEventListener('form-sended', this.formSubmitHandler)

    this.removePaymentMethods()
    this.template.remove()
  }

  renderPaymentMethods() {
    const fragment = document.createDocumentFragment()

    this.methods.forEach((method) => {
      const paymentMethodElement = createElement(getPaymentMethodTemplate(method))
      render(fragment, paymentMethodElement)
    })

    render(this.methodsWrapper, fragment)
  }

  removePaymentMethods() {
    this.methodsWrapper.innerHTML = ''
  }

  accordionInit() {
    const detail = this.template.querySelector('[data-accordion]')
    const spoilers = detail.querySelectorAll('.ui-spoiler')

    detail.addEventListener('click', evt => {
      const target = evt.target.closest('summary')

      if (target) {
        const parent = target.parentElement

        if (!parent.open) {
          const gtmAttribute = detail.dataset.gtm
          const itemText = target.innerText

          if (gtmAttribute && itemText) {
            const eventName = `${gtmAttribute}-accordion-click`
            window.$analytics?.push(eventName, { text: itemText })
          }
        }
      }
    })

    spoilers.forEach(spoiler => new Spoiler(spoiler))
  }

  formInit() {
    const autopayment = this.methods.find(method => method.autopayment)?.autopayment || {}
    const paymentForm = new Form(this.form, null, null, autopayment)
    paymentForm.init()

    paymentForm.onCloudPayment = () => {
      this.emitFormEvent(this.form, { formData: new FormData(this.form) }, 'form-success')
    }
  }

  setButtonContent() {
    this.buttonContent.innerHTML = `
      <span class="f f--16 f--m">${this.selectPaymentType.dataset.paymentType}</span>
      <span class="f f--12">${this.selectPaymentType.dataset.paymentPrice}</span>`
  }

  setDetailsHeight(height = null) {
    const details = this.selectMethod.querySelector('.extended-autopayment-method__details')
    details.style.height = height !== null ? height : `${details.scrollHeight}px`
  }

  emitFormEvent(form, params, name) {
    const customEvent = new Event(name)

    customEvent.sendingResult = params
    form.dispatchEvent(customEvent)
  }

  formChangeHandler = (evt) => {
    this.setDetailsHeight(0)

    this.selectPaymentType = evt.target
    this.selectMethod = evt.target.closest('.extended-autopayment-method')

    this.setDetailsHeight()
    this.setButtonContent()

    window.$analytics?.push('autopayment-modal-type-change', {
      label: evt.target.dataset.analytics
    })
  }

  formSubmitHandler = () => {
    window.$analytics?.push('autopayment-modal-type-submit', {
      label: this.selectPaymentType?.dataset.analytics
    })
  }

  changeViewForBGroup() {
    const methods = this.wrapper.querySelectorAll('.extended-autopayment-method')
    const cloudpaymentsType = this.wrapper.querySelector('#cloudpayments')

    if (!cloudpaymentsType) {
      return
    }

    cloudpaymentsType.querySelector('.extended-autopayment-method__input').checked = true
    cloudpaymentsType.querySelector('.extended-autopayment-method__list').remove()
    cloudpaymentsType.querySelector('.extended-autopayment-method__input').dataset.paymentPrice = 'С дополнительной скидкой'

    if (methods[0] !== cloudpaymentsType) {
      const cloudpayment = Array.from(methods).find(i => i.id === 'cloudpayments')

      cloudpaymentsType.remove()
      methods[0].insertAdjacentElement('beforebegin', cloudpayment)

      this.selectPaymentType = this.wrapper.querySelector('.extended-autopayment-method__input:checked')
      this.selectMethod = cloudpayment
    }
  }
}
